import useSWR from "swr";
import { getClients } from "./service";
import { UseClientScoringRulesModel } from "./types";

const useClientScoringRules = (): UseClientScoringRulesModel => {
  const { data, error, isLoading, mutate } = useSWR(`/clients`, () =>
    getClients(),
  );

  return {
    data: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useClientScoringRules;
